import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { isReactComponent } from ".";
import {
  GrapesEditor,
  GrapesTypes,
  LoadComponentOptions,
} from "../../defenitions";
import SendConsentWithHPR from "../../../Base/SendConsentWithHPR";
import { Provider } from "react-redux";
import store from "../../../../store/store";

type EmailConsentProps = {
  text: string;
  message: string;
    setEmail: boolean
    emailLabel: string;
    hprLabel: string;

};

export const EmailConsentWithHpr = (props: EmailConsentProps): JSX.Element => {
    const { text, message, setEmail, emailLabel, hprLabel } = props;


  return (

      <SendConsentWithHPR emailLabel={emailLabel} hprLabel={hprLabel} text={text} message={message} setEmail={setEmail} />

  );
};

export default function (
  editor: GrapesEditor,
  options: LoadComponentOptions
): void {
  const domComponents = editor.DomComponents;
  const blockManager = editor.BlockManager;
  const defaultType = domComponents.getType("default");
  const { model, view } = defaultType;
  const compName = "EmailConsentWithHpr";

  blockManager.add(GrapesTypes.EmailConsentWithHpr, {
    label: "EmailConsentWithHpr",
    category: options.categoryLabel,
    attributes: { class: "fa fa-sign-in" },
    textable: 1,
    content: `<span data-gjs-type="${GrapesTypes.EmailConsentWithHpr}"></span>`,
  });

  const traits = [
    {
      label: "Button text",
      name: "text",
      changeProp: 1,
    },
    {
      label: "Message",
      name: "message",
      changeProp: 1,
    },
    {
      label: "Set email",
      name: "setEmail",
      changeProp: 1,
      },
      {
          label: "Email label",
          name: "emailLabel",
          changeProp: 1,
      },
      {
          label: "Hpr label",
          name: "hprLabel",
          changeProp: 1,
      }

  ];


  domComponents.addType(GrapesTypes.EmailConsentWithHpr, {
    isComponent(el: HTMLElement) {
      if (
        (el.getAttribute &&
          el.getAttribute("data-gjs-type") ===
          GrapesTypes.EmailConsentWithHpr) ||
        (el.attributes &&
          (el.attributes as any)["data-gjs-type"] ===
          GrapesTypes.EmailConsentWithHpr) ||
        isReactComponent(el, compName)
      ) {
        return {
          type: GrapesTypes.EmailConsentWithHpr,
        };
      }
    },
    model: {
      defaults: {
        ...model.prototype.defaults,
        droppable: false,
        draggable: true,
        text: "Thank you",
        setEmail: true,
        traits: [...model.prototype.defaults.traits, ...traits],
      },
    },
    view: view.extend({
      init() {
        traits.forEach((trait) => {
          this.listenTo(this.model, `change:${trait.name}`, this.handleChanges);
        });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      handleChanges(e: any, value: any) {
        ReactDOM.unmountComponentAtNode(this.el);
        this.render();
      },
      onRender() {
        const { el } = this;
        const comps = this.model.get("components");
        const { text, message, setEmail, emailLabel, hprLabel } = this.model.attributes;
        comps.reset();

        const compString = `<${compName} emailLabel='${emailLabel}' hprLabel='${hprLabel}'  text='${text}' message='${message}' setEmail='${setEmail}'></${compName}>`;
        comps.add(compString);

          ReactDOM.render(<Provider store={store}>
              <SendConsentWithHPR emailLabel={emailLabel} hprLabel={hprLabel} text={text} message={message} setEmail={setEmail} />
        </Provider>, el);
      },
    }),
  });
}
